// extracted by mini-css-extract-plugin
export default {"rating":"by-z","numberOfStars":"cy-z","count":"dy-z","barGraphSpacing":"ey-z","barGraph":"fy-z"};